import React, { useState } from 'react';
import API from '../../api';
import { AlertTriangle, Loader2, CheckCircle2 } from 'lucide-react';
import { useConfirm } from '../../components/ConfirmDialog';

const CONFERMA_TARGET = 'RESET-EDILCIMA-CONFERMO';

export default function ResetWorkspaceTab() {
  const confirm = useConfirm();
  const [conferma, setConferma] = useState('');
  const [cancellaClienti, setCancellaClienti] = useState(true);
  const [cancellaFornitori, setCancellaFornitori] = useState(true);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const isValid = conferma === CONFERMA_TARGET;

  const esegui = async () => {
    if (!isValid) return;
    if (!await confirm({
      title: 'Reset workspace — ATTENZIONE',
      message: 'Sei davvero sicuro?\n\nVerranno cancellati TUTTI i dati operativi: pratiche, preventivi, computi, cantieri, fatture, contabilità.\n\nOperazione IRREVERSIBILE.',
      confirmLabel: 'Sì, resetta tutto',
      variant: 'danger',
    })) return;
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const r = await API.post('/api/admin/reset-workspace', {
        conferma,
        cancella_clienti: cancellaClienti,
        cancella_fornitori: cancellaFornitori,
      });
      setResult(r.data);
      setConferma('');
    } catch (e) {
      setError(e?.response?.data?.detail || 'Errore durante il reset');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="reset-workspace-tab" className="max-w-3xl">
      <div className="bg-red-50 border-2 border-red-200 rounded-md p-5 mb-5">
        <div className="flex items-start gap-3">
          <AlertTriangle size={24} className="text-red-600 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-black text-red-900 text-lg">Reset Ambiente di Lavoro</h3>
            <p className="text-sm text-red-800 mt-1">
              Cancella DEFINITIVAMENTE pratiche, preventivi, computi metrici, cantieri,
              SAL, messaggi cantiere, allegati, fatture, pagamenti e spese.
            </p>
            <p className="text-sm text-red-800 mt-2">
              <strong>Mantenuto integro:</strong> Prezzario, Listino Aziendale, Formazione AI,
              Training preventivi, Utenti.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3 bg-white border border-slate-200 rounded-md p-5">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={cancellaClienti}
            onChange={(e) => setCancellaClienti(e.target.checked)}
            data-testid="reset-cancella-clienti"
            className="w-4 h-4"
          />
          <span className="text-sm font-semibold">Cancella anche tutti i Clienti</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={cancellaFornitori}
            onChange={(e) => setCancellaFornitori(e.target.checked)}
            data-testid="reset-cancella-fornitori"
            className="w-4 h-4"
          />
          <span className="text-sm font-semibold">Cancella anche tutti i Fornitori</span>
        </label>

        <div className="pt-3 border-t border-slate-200">
          <label className="block text-sm font-bold text-slate-700 mb-1">
            Per confermare digita esattamente: <code className="bg-slate-100 px-2 py-0.5 rounded text-red-700 font-mono">{CONFERMA_TARGET}</code>
          </label>
          <input
            type="text"
            value={conferma}
            onChange={(e) => setConferma(e.target.value)}
            data-testid="reset-conferma"
            placeholder="Digita la frase di conferma"
            className="w-full px-3 py-2.5 border-2 border-slate-200 rounded-md font-mono focus:border-red-400 focus:ring-2 focus:ring-red-200"
          />
        </div>

        <button
          onClick={esegui}
          disabled={!isValid || loading}
          data-testid="reset-esegui-btn"
          className="w-full py-3 bg-red-600 text-white font-black rounded-md hover:bg-red-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all active:scale-95 flex items-center justify-center gap-2"
        >
          {loading ? (
            <><Loader2 size={18} className="animate-spin" /> Cancellazione in corso...</>
          ) : (
            <>ESEGUI RESET WORKSPACE</>
          )}
        </button>
      </div>

      {error && (
        <div className="mt-4 bg-red-50 border border-red-300 rounded-md p-4 text-sm text-red-800">
          {error}
        </div>
      )}

      {result && (
        <div className="mt-4 bg-emerald-50 border border-emerald-300 rounded-md p-4" data-testid="reset-result">
          <div className="flex items-center gap-2 mb-2">
            <CheckCircle2 size={18} className="text-emerald-700" />
            <span className="font-black text-emerald-900">Reset completato</span>
          </div>
          <p className="text-sm text-emerald-800 font-bold mb-2">
            Totale record cancellati: {result.totale_cancellati}
          </p>
          <details className="text-xs text-emerald-700">
            <summary className="cursor-pointer font-semibold">Dettaglio per collezione</summary>
            <pre className="mt-2 bg-white p-2 rounded overflow-x-auto">
              {JSON.stringify(result.dettaglio, null, 2)}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
}
